<template>
	<div class="flex-grow flex flex-col">
		<p
			class="px-2.5 py-2 cursor-pointer group flex items-center text-sm leading-5 font-medium rounded-md text-gray-300 hover:text-white hover:bg-white hover:bg-opacity-10 focus:outline-none focus:bg-white focus:bg-opacity-10 transition ease-in-out duration-150"
			:class="{ 'bg-opacity-50 bg-gray-900 text-white' : isHighlight }" @click.prevent="handleToggleState">
			<i class="w-6 m-1 flex-shrink-0 text-center text-xl transition ease-in-out duration-150" :class="icon"></i>
			<button type="button" class="flex-1 ml-3 flex justify-between items-center">
				<OpacityScaleTransition enter-extra="-translate-x-8">
					<span v-if="!compact">{{ title }}</span>
				</OpacityScaleTransition>
				<i class="w-6 opacity-75 text-white fa fa-caret-down flex-shrink-0 text-center text-sm transition ease-in-out duration-150"
				   :class="{'fa-caret-down' : !isOpen, 'fa-caret-up' : isOpen}"></i>
			</button>
			<template v-if="compact">
				<div class="hidden absolute left-1 z-30 flex px-3 py-1 bg-white border shadow group-hover:flex rounded text-black items-center space-x-2">
					<i class="w-6 m-1 flex-shrink-0 text-center text-xl transition ease-in-out duration-150 text-turquoise" :class="icon"></i>
					<p>{{ title }}</p>
				</div>
			</template>
		</p>
		<!-- Common !-->
		<OpacityScaleTransition enter-extra="translate-x-8">
			<div v-if="!compact && isOpen" class="flex flex-col space-y-2 py-2 pl-3 pr-0">
				<slot />
			</div>
		</OpacityScaleTransition>
	</div>
</template>

<script>
import OpacityScaleTransition from "@/components/OpacityScaleTransition.vue"

export default {
	name: "SidebarExpandMenuItem",
	components: { OpacityScaleTransition },
	model: {
		prop: "open",
		event: "update:open"
	},
	props: {
		title: {
			type: String,
			required: true
		},
		icon: {
			type: String,
			required: true
		},
		to: {
			type: Object
		},
		openOnPath: String,
		compact: Boolean
	},
	data() {
		return {
			isOpen: false,
			isHighlight: false
		}
	},
	methods: {
		/**
		 * Handle toggle state
		 */
		handleToggleState() {
			this.isOpen = !this.isOpen
			this.isHighlight = !this.isHighlight

			if ((this.isOpen || this.isHighlight) && this.to) {
				try {
					this.$router.push(this.to)
				} catch (err) {

				}
			}
		}
	},
	created() {
		if (this.openOnPath) {
			this.isHighlight = this.isOpen = this.compact
				? this.openOnPath === this.$router.currentRoute.path
				: (new RegExp(this.openOnPath)).test(this.$router.currentRoute.fullPath)
		}
	},
	watch: {
		compact(v){
			if(this.isOpen && v) this.isOpen = false
		},
		'$route'() {
			if(this.compact) {
				this.isHighlight = this.openOnPath === this.$router.currentRoute.path
			}
		}
	}
}
</script>